import { DocsStep, ReviewStep } from "../interfaces/purchase-order.interface";

export class Constants {
  /**
   * The catalog of cancellation reasons comes from the backend, but this code is part of the
   * contract: it is the only reason that asks the user for a free-text message.
   */
  public static cancel_reason_with_message = "other";

  public static docs_steps: DocsStep[] = [
    {
      id: 0,
      view: null,
      cardless: true,
    },
    {
      id: 1,
      view: "no_payments",
      cardless: true,
    },
    {
      id: 2,
      view: "information",
      cardless: true,
    },
    {
      id: 5,
      view: "insurance",
      cardless: true,
    },
    {
      id: 5.5,
      view: "nextcar_docs",
      cardless: true,
    },
    {
      id: 6,
      title: "Cadena de facturación",
      view: "billing_chain",
      category: [{ value: "purchase_order_invoice_process_evidence" }],
    },
    {
      id: 7,
      title: "Reporte de repuve",
      view: "repuve",
      category: [{ value: "purchase_order_repuve" }],
    },
    {
      id: 8,
      title: "Tenencias",
      view: "fee",
      category: [{ value: "purchase_order_tenure_procedure" }],
    },
    {
      id: 9,
      title: "Altas",
      view: "enroll",
      category: [{ value: "purchase_order_registration_procedure" }, { value: "purchase_order_evidence_enroll" }],
    },
    {
      id: 10,
      title: "Bajas",
      view: "disenroll",
      category: [{ value: "purchase_order_cancellation_procedure" }, { value: "purchase_order_evidence_disenroll" }],
    },
    {
      id: 11,
      title: "Tarjeta de circulación",
      view: "circulation_card",
      category: [{ value: "purchase_order_circulation_card" }],
    },
    {
      id: 12,
      title: "Verificación",
      view: "verification",
      category: [{ value: "purchase_order_plates_proof" }],
    },
    {
      id: 13,
      title: "Infracciones",
      view: "infractions",
      category: [{ value: "purchase_order_infringement_procedure" }, { value: "purchase_order_verify_infractions" }],
    },
    {
      id: 14,
      view: "docs_completed",
      cardless: true,
    },
  ];

  public static review_steps: ReviewStep[] = [
    {
      id: 0,
      value: "initial_investment",
      label: "Inversión inicial",
    },
    {
      id: 1,
      value: "information",
      label: "Información",
    },
    {
      id: 2,
      value: "documents",
      label: "Documentos",
    },
    {
      id: 3,
      value: "notification",
      label: "Notificación",
    },
  ];

  public static review_steps_new_asset: ReviewStep[] = [
    {
      id: 0,
      value: "initial_investment",
      label: "Inversión inicial",
    },
    {
      id: 1,
      value: "information",
      label: "Información",
    },
    {
      id: 2,
      value: "notification",
      label: "Notificación",
    },
  ];

  public static prevalidation_review_steps: ReviewStep[] = [
    {
      id: 1,
      value: "documents",
      label: "Documentos",
    },
    {
      id: 2,
      value: "notification",
      label: "Notificación",
    },
  ];

  public static allowed_contract_statuses: string[] = ["with_incidents", "deprecated", "missing_documents"];

  public static type_user_permiss_cancel_po: string[] = ["embajador", "developer"];

  public static document_allowed_extensions: { [key: string]: string } = {
    billing_chain: "image/*,application/pdf",
    repuve: "image/*,application/pdf",
    fee: "image/*,application/pdf",
    enroll: "image/*,application/pdf",
    disenroll: "image/*,application/pdf",
    circulation_card: "image/*,application/pdf",
    verification: "image/*,application/pdf",
    infractions: "image/*,application/pdf",
    insurance: "image/*,application/pdf",
  };

  public static document_example: { [key: string]: string } = {
    billing_chain:
      "https://sites.google.com/nexu.mx/operaciones/ordenes-de-compra/ejemplos-mesa-de-control/ejemplos-de-facturas",
    fee: "https://sites.google.com/nexu.mx/operaciones/ordenes-de-compra/ejemplos-mesa-de-control/certificaciones",
    disenroll: "https://sites.google.com/nexu.mx/operaciones/ordenes-de-compra/ejemplos-mesa-de-control/baja-de-placas",
    circulation_card:
      "https://sites.google.com/nexu.mx/operaciones/ordenes-de-compra/ejemplos-mesa-de-control/tarjeta-de-circulaci%C3%B3n",
    verification:
      "https://sites.google.com/nexu.mx/operaciones/ordenes-de-compra/ejemplos-mesa-de-control/verificaci%C3%B3n",
    infractions:
      "https://sites.google.com/nexu.mx/operaciones/ordenes-de-compra/ejemplos-mesa-de-control/infracci%C3%B3n",
  };
}
